<script>
    import { t } from '$m7-library/utils/lang.js';

    let { label, sortKey, sortConfig, onsort = () => {} } = $props();

    const isCurrentSort = $derived(sortConfig.key === sortKey);
</script>

<th scope="col" class="tw:px-4 tw:pt-2 tw:select-none">
    <button
        class="tw:flex tw:items-center tw:gap-2 tw:font-bold tw:uppercase"
        onclick={() => onsort()}
        aria-label={`${t('Sort by')} ${label}`}
    >
        {label}
        {#if isCurrentSort}
            <span class="tw:text-gray-600">{@html sortConfig.direction === 'desc' ? '&#9660;' : '&#9650;'}</span>
        {/if}
    </button>
</th>